var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7202 34C13.7811 34 14.7985 34.4214 15.5486 35.1716C16.2988 35.9217 16.7202 36.9391 16.7202 38C16.7202 39.0609 16.2988 40.0783 15.5486 40.8284C14.7985 41.5786 13.7811 42 12.7202 42C11.6593 42 10.6419 41.5786 9.89179 40.8284C9.14164 40.0783 8.72021 39.0609 8.72021 38C8.72021 36.9391 9.14164 35.9217 9.89179 35.1716C10.6419 34.4214 11.6593 34 12.7202 34ZM12.7202 34H34.7202M12.7202 34V6H8.72021M34.7202 34C35.7811 34 36.7985 34.4214 37.5486 35.1716C38.2988 35.9217 38.7202 36.9391 38.7202 38C38.7202 39.0609 38.2988 40.0783 37.5486 40.8284C36.7985 41.5786 35.7811 42 34.7202 42C33.6593 42 32.6419 41.5786 31.8918 40.8284C31.1416 40.0783 30.7202 39.0609 30.7202 38C30.7202 36.9391 31.1416 35.9217 31.8918 35.1716C32.6419 34.4214 33.6593 34 34.7202 34ZM12.7202 10L24.7202 10.858M38.9962 24.004L38.7102 26.004H12.7102M30.7202 12H42.7202M36.7202 6V18",
    stroke: "#31B9B5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartIcon);
export default __webpack_public_path__ + "static/media/shopping_cart_icon.9fd627884d4547770583ae4d98afa5f8.svg";
export { ForwardRef as ReactComponent };